"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var __1 = require("../../");
var getRecipientToken_1 = require("../../../utils/getRecipientToken");
var Message_1 = require("./Message");
var Option_1 = require("./Option");
var normalizeString = function (text) {
    return text.toLowerCase().replace(/\s/g, '');
};
var DELIVERY_CHANGES;
(function (DELIVERY_CHANGES) {
    DELIVERY_CHANGES["ADDRESS_CHANGE"] = "ADDRESS_CHANGE";
    DELIVERY_CHANGES["NEIGHBOUR_DELIVERY"] = "NEIGHBOUR_DELIVERY";
})(DELIVERY_CHANGES = exports.DELIVERY_CHANGES || (exports.DELIVERY_CHANGES = {}));
var Conversation = /** @class */ (function () {
    function Conversation(trunkrsNr, postalCode, history) {
        this.trunkrsNr = trunkrsNr;
        this.postalCode = postalCode;
        this.sessionId = undefined;
        this.messageHistory = history.map(function (historicEntry) { return new Message_1.Message(historicEntry.message, historicEntry.userType, historicEntry.timestamp, !!historicEntry.options
            && !!historicEntry.options.length
            && historicEntry.options.map(function (option) { return Option_1.Option.mapBEOptionToOption({
                text: option.label,
                value: option.value.input.text,
            }); }) || []); });
    }
    Conversation.setup = function (trunkrsNr, postalCode) {
        return __awaiter(this, void 0, void 0, function () {
            var normalizedTrunkrsNr, normalizedPostalCode, history;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        normalizedTrunkrsNr = normalizeString(trunkrsNr);
                        normalizedPostalCode = normalizeString(postalCode);
                        return [4 /*yield*/, Conversation.fetchHistory(normalizedTrunkrsNr, normalizedPostalCode)];
                    case 1:
                        history = _a.sent();
                        return [2 /*return*/, new Conversation(normalizedTrunkrsNr, normalizedPostalCode, history)];
                }
            });
        });
    };
    Conversation.fetchHistory = function (trunkrsNr, postalCode) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, __1.Model.makeRequest("/communications/track-and-talk/" + trunkrsNr + "/" + normalizeString(postalCode) + "/message/history", __1.METHOD.GET, undefined, false, { Authorization: getRecipientToken_1.getRecipientToken(trunkrsNr, postalCode) })];
            });
        });
    };
    Object.defineProperty(Conversation.prototype, "getMessageHistory", {
        get: function () {
            return this.messageHistory;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Conversation.prototype, "getCurrentOptions", {
        get: function () {
            var latestMessage = !!this.messageHistory
                && !!this.messageHistory.length
                && (this.messageHistory.slice().pop());
            return !!latestMessage && latestMessage.getOptions || undefined;
        },
        enumerable: true,
        configurable: true
    });
    Conversation.prototype.sendMessage = function (message, display) {
        return __awaiter(this, void 0, void 0, function () {
            var input, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        input = {
                            text: message,
                            displayText: display,
                            type: 'TEXT',
                        };
                        return [4 /*yield*/, this.proxyMessage(input)];
                    case 1:
                        result = _a.sent();
                        switch (result.output.type) {
                            case 'TEXT':
                                return [2 /*return*/, this.storeResult(result.output, display || message)];
                            case 'MODAL_INDICATOR':
                                return [2 /*return*/, result.output];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Conversation.prototype.sendAction = function (location, type) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.proxyMessage({
                            location: location,
                            type: type,
                        })];
                    case 1:
                        result = _a.sent();
                        switch (result.output.type) {
                            case 'TEXT':
                                return [2 /*return*/, this.storeResult(result.output)];
                            case 'MODAL_INDICATOR':
                                return [2 /*return*/, result.output];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Conversation.prototype.storeResult = function (output, userMessage) {
        var messages = userMessage ? [
            new Message_1.Message(userMessage, 'recipient', moment_1.default(), []),
        ] : [];
        messages.push.apply(messages, output.reply.map(function (messagePart) { return new Message_1.Message(messagePart, 'bot', output.timestamp, output.options.map(function (option) { return Option_1.Option.mapBEOptionToOption({
            text: option.label,
            value: option.value.input.text,
        }); })); }));
        this.messageHistory = this.messageHistory.concat(messages);
        return messages;
    };
    Conversation.prototype.proxyMessage = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            var body;
            return __generator(this, function (_a) {
                body = {
                    input: input,
                    sessionToken: this.sessionId,
                };
                return [2 /*return*/, __1.Model.makeRequest("/communications/track-and-talk/" + this.trunkrsNr + "/" + this.postalCode + "/message/", __1.METHOD.POST, body, false, {
                        Authorization: getRecipientToken_1.getRecipientToken(this.trunkrsNr, this.postalCode),
                    })];
            });
        });
    };
    return Conversation;
}());
exports.Conversation = Conversation;
